import { inject } from '@angular/core';
import { GetMenuListUseCase } from '@app/application';
import { AuthCoordinatorService } from '@app/shared/services/auth-coordinator.service';
import { AuthorizationService } from '@app/shared/services/authorization.service';
import { DevFunctionCodeService } from '@app/shared/services/dev-function-code.service';
import { setMenuListAction } from '@app/state/system/system.actions';
import { Store } from '@ngrx/store';
import { catchError, firstValueFrom, of } from 'rxjs';
import { filter, take } from 'rxjs/operators';

export async function menuInitializer() {
  const getMenuListUseCase = inject(GetMenuListUseCase);
  const store = inject(Store);
  const authCoordinator = inject(AuthCoordinatorService);
  const authorizationService = inject(AuthorizationService);
  const devFunctionCodes = inject(DevFunctionCodeService);

  // Dev only: the picked function codes replace the menu-list API
  if (devFunctionCodes.active()) {
    devFunctionCodes.syncMenuList();
    return;
  }

  if (!authorizationService.needAuthorization()) return;

  await firstValueFrom(
    authCoordinator.isInitializing$.pipe(
      filter(isInitializing => !isInitializing),
      take(1)
    )
  );
  if (!authCoordinator.isAuthenticated()) {
    store.dispatch(setMenuListAction({ menuList: [], loaded: true }));
    return;
  }

  const response = await firstValueFrom(
    getMenuListUseCase.execute({ appCode: 'VAL' }).pipe(
      catchError(error => {
        return of([]);
      })
    )
  );
  store.dispatch(setMenuListAction({ menuList: response, loaded: true }));
}
